






































// vue
import Vue from 'vue'
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { TableListReasonForTerminationWork } from '@/components/config'
import ModalCreateEditReasonForTerminationWork from './modalCreateEdit.vue'

// services
import { ReasonForTerminationWorkService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { ReasonForTerminationWorkForm, ReasonForTerminationWorkModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

const newItem: ReasonForTerminationWorkForm = {
  name: '',
  is_active: true
}

export default defineComponent({
  name: 'ReasonForTerminationWorkIndex',
  components: {
    PageHeader,
    TableListReasonForTerminationWork,
    ModalCreateEditReasonForTerminationWork
  },
  setup (props, { refs }) {
    const showModal = ref(false)
    const reason: Ref<ReasonForTerminationWorkForm> = ref(newItem)
    const title = ref('Motivos de Cese de Trabajo')
    const actionForm = ref('save')
    const idItemEdit: Ref<number|null> = ref(null)

    const items = ref([
      {
        text: 'Dashboard'
      },
      {
        text: 'Motivos de Cese de Trabajo',
        active: true
      }
    ])

    const tableList = computed((): Vue & { getreasonsWithPagination: () => void } => {
      return refs.table_list as Vue & { getreasonsWithPagination: () => void }
    })

    const itemInit = computed(() => {
        return newItem
    })

    const addNew = () => {
      idItemEdit.value = null
      actionForm.value = 'save'
      reason.value = newItem
      showModal.value = true
    }

    const hideModal = (event: BvModalEvent) => {
      if (event.trigger !== 'ok') {
        showModal.value = false
      }
    }

    const editItem = (item: ReasonForTerminationWorkModel) => {
      reason.value = {
        name: item.name,
        is_active: item.is_active
      }
      if (item.id) {
        idItemEdit.value = Number(item.id)
      }
      actionForm.value = 'update'
      showModal.value = true
    }

    const changeStatus = async (item: ReasonForTerminationWorkModel) => {
      try {
        loading('show')
        await ReasonForTerminationWorkService.update(item.id, {
          name: item.name,
          is_active: item.is_active
        })
        tableList.value.getreasonsWithPagination()
        alerts.success()
      } catch (e) {
        alerts.error()
      }
      loading('hide')
    }

    const deleteItem = async (item: ReasonForTerminationWorkModel) => {
      const msg = 'Seguro que desea eliminar el Motivo de Cese Seleccionado'
      const confirm = await alerts.confirm(msg)
      if (confirm && item.id) {
        loading('show')
        await ReasonForTerminationWorkService.delete(item.id)
        tableList.value.getreasonsWithPagination()
        alerts.success()
        loading('hide')
      }
    }

    return {
      items,
      title,
      addNew,
      editItem,
      deleteItem,
      tableList,
      reason,
      itemInit,
      hideModal,
      idItemEdit,
      actionForm,
      showModal,
      changeStatus
    }
  }
})
